// Mapas de display para campos de fallas.
// Usar siempre estas funciones en la capa de presentación; la BD guarda los valores en minúsculas.

const TIPO_FALLA_MAP = {
  electrica:    'Eléctrica',
  mecanica:     'Mecánica',
  hidraulica:   'Hidráulica',
  neumatica:    'Neumática',
  electronica:  'Electrónica',
  software:     'Software',
  calibracion:  'Calibración',
  otra:         'Otra',
};

const ESTADO_FALLA_MAP = {
  reportada:           'Reportada',
  en_revision:         'En Revisión',
  esperando_repuesto:  'Esperando Repuesto',
  resuelta:            'Resuelta',
};

const PRIORIDAD_MAP = {
  baja:    'Baja',
  media:   'Media',
  alta:    'Alta',
  urgente: 'Urgente',
};

const fallback = (v) =>
  v ? v.charAt(0).toUpperCase() + v.slice(1) : '—';

export const formatTipoFalla  = (v) => TIPO_FALLA_MAP[v]  ?? fallback(v);
export const formatEstadoFalla = (v) => ESTADO_FALLA_MAP[v] ?? fallback(v);
export const formatPrioridad  = (v) => PRIORIDAD_MAP[v]  ?? fallback(v);
